import { getHostApi } from '@/utils';
import getDefaultHeader from 'lowcode/utils/service/getDefaultHeader';
import { getBlogTagFromList } from '../utils';
const getBlogTagName = (itemA: any, categoryId: string) => {
    const blogTagList = itemA?.blogTagList || [];
    const tagItem = getBlogTagFromList(blogTagList, categoryId);

    return tagItem?.tag;
};
export const queryCategoryItems = async (locale: string, params: any, options?: any) => {
    const API_HOST = getHostApi(locale as string).NEXT_PUBLIC_API_HOST;
    const headers = getDefaultHeader(locale as string);
    const categoryIds = params?.categoryIds ? params?.categoryIds : [];
    const categoryId = params.categoryId;
    const condData = {
        page: params.page || 1,
        type: 'BLOG_DETAIL',
        tagUrl: categoryId,
        tagUrls: categoryIds,
        size: params.size || 18,
    };
    try {
        const res = await fetch(`${API_HOST}/blogModule/page`, {
            method: 'POST',
            // @ts-ignore
            headers: {
                ...headers,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(condData),
        });
        const data = await res.json();
        const dataA = data?.data || {};
        const itemsA = dataA?.content || [];
        const categoryName = getBlogTagName(itemsA[0] || {}, categoryId) || '';

        return {
            items: dataA?.content || [],
            categoryName: categoryName,
            total: dataA?.total || 0,
        };
    } catch (error) {}
    return {
        total: 0,
        categoryName: '',
        items: [],
    };
};
// 增加了置顶优先
export const queryCategoryTopItems = async (locale: string, params: any, options?: any) => {
    const API_HOST = getHostApi(locale as string).NEXT_PUBLIC_API_HOST;
    const headers = getDefaultHeader(locale as string);
    const categoryIds = params?.categoryIds ? params?.categoryIds : [];
    const categoryId = params.categoryId;
    const condData = {
        page: params.page || 1,
        type: 'BLOG_DETAIL',
        tagUrl: categoryId,
        tagUrls: categoryIds,
        size: params.size || 18,
    };
    try {
        const res = await fetch(`${API_HOST}/blogModule/pinPage`, {
            method: 'POST',
            // @ts-ignore
            headers: {
                ...headers,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(condData),
        });
        const data = await res.json();
        const dataA = data?.data || {};
        const itemsA = dataA?.content || [];
        const categoryName = getBlogTagName(itemsA[0] || {}, categoryId) || '';

        return {
            items: dataA?.content || [],
            categoryName: categoryName,
            total: dataA?.total || 0,
        };
    } catch (error) {}
    return {
        total: 0,
        categoryName: '',
        items: [],
    };
};

export const queryCategoryItemsList = async (locale: string, params: any, options?: any) => {
    const API_HOST = getHostApi(locale as string).NEXT_PUBLIC_API_HOST;
    const headers = getDefaultHeader(locale as string);
    const blogIds1 = params?.ids || [];
    const blogIds2 = blogIds1.join(',');

    try {
        const res = await fetch(`${API_HOST}/blogModule/list?blogIds=${blogIds2}`, {
            method: 'GET',
            // @ts-ignore
            headers: {
                ...headers,
            },
        });
        const data = await res.json();

        const dataA = data?.data || [];
        return dataA;
    } catch (error) {}
    return [];
};

export const queryBlogTagList = async (locale: string, params: any, options?: any) => {
    const API_HOST = getHostApi(locale as string).NEXT_PUBLIC_API_HOST;
    const headers = getDefaultHeader(locale as string);
    const condData = {};
    try {
        const res = await fetch(`${API_HOST}/blogTag/list`, {
            method: 'GET',
            // @ts-ignore
            headers: {
                ...headers,
            },
        });
        const data = await res.json();
        const dataA = data?.data || [];

        return {
            items: dataA || [],
        };
    } catch (error) {}
    return {
        items: [],
    };
};
